import { useMutationInvoice } from '@/hooks/orderhistory.hook';
import { Button } from '../components';
import { SpinnerBox } from './spinner-box';
import { useInvoicePDF } from '@/hooks/pdf.hook';
import { SearchStatus } from '@/types/order-management';
import dayjs from 'dayjs';
import { useAppStore } from '@/store/app-store';
import { useContext } from 'react';
import LanguageContext from '@/context/language';
import clsx from 'clsx';

function InvoicePdf({
  orderNumber,
  status,
  children,
  className,
}: {
  orderNumber: string;
  status: SearchStatus;
  children?: React.ReactNode;
  className?: string;
}) {
  const { configByCountry } = useAppStore();
  const { lang } = useContext(LanguageContext);
  const { mutateAsync: asyncInvoice, isLoading: invoiceLoading } = useMutationInvoice();
  const { mutateAsync: asyncInvoicePDF, isLoading: invoicePdfLoading } = useInvoicePDF();

  if (status !== 'Shipped' || !configByCountry?.isShowInvoiceInOrder) return null;

  const onClickInvoice = async () => {
    const invoiceResponse = await asyncInvoice(orderNumber);
    if (!invoiceResponse?.data) return;
    const { url, type } = await asyncInvoicePDF({
      data: invoiceResponse.data,
      lang,
    });
    const a = document.createElement('a');
    a.href = url;
    if (type === 'pdf') {
      a.download = `invoice_${orderNumber}.pdf`;
    } else if (type === 'zip') {
      const currentTime = dayjs().format('YYYYMMDDHHmmss');
      a.download = `invoice_${currentTime}.zip`;
    }
    a.click();
  };

  return (
    <SpinnerBox isLoading={invoiceLoading || invoicePdfLoading}>
      <Button className={clsx('p-0 w-full', className)} onClick={onClickInvoice} disabled={!orderNumber}>
        {children}
      </Button>
    </SpinnerBox>
  );
}

export { InvoicePdf };
